import { render, staticRenderFns } from "./erikoistujien-seuranta-card.vue?vue&type=template&id=fb60690e&scoped=true&"
import script from "./erikoistujien-seuranta-card.vue?vue&type=script&lang=ts&"
export * from "./erikoistujien-seuranta-card.vue?vue&type=script&lang=ts&"
import style0 from "./erikoistujien-seuranta-card.vue?vue&type=style&index=0&id=fb60690e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb60690e",
  null
  
)

export default component.exports